import { apiService } from './api';
import { Permission, UserPermission, Pagination } from '../types';

export const permissionService = {
  // Get all available permissions
  getPermissions: async (params?: {
    page?: number;
    limit?: number;
    module?: string;
  }) => {
    const response = await apiService.get<{
      permissions: Permission[];
      pagination: Pagination;
    }>('/admin/permissions', params);
    return response.data;
  },

  // Get user permissions for a specific center
  getUserPermissions: async (userId: string, centerId: string) => {
    const response = await apiService.get<UserPermission[]>(
      `/permissions/user/${userId}/center/${centerId}`
    );
    return response.data;
  },

  // Get all users with their permissions for a center
  getCenterUsersWithPermissions: async (centerId: string, params?: {
    page?: number;
    limit?: number;
  }) => {
    const response = await apiService.get<{
      users: Array<{
        _id: string;
        name: string;
        email: string;
        role: string;
        permissions: Permission[];
      }>;
      pagination: Pagination;
    }>(`/permissions/center/${centerId}/users`, params);
    return response.data;
  },

  // Get all users with their permissions across all centers (Super Admin only)
  getAllUsersWithPermissions: async (params?: {
    page?: number;
    limit?: number;
  }) => {
    const response = await apiService.get<{
      users: Array<{
        _id: string;
        name: string;
        email: string;
        role: string;
        centerId: {
          _id: string;
          name: string;
        };
        permissions: Permission[];
      }>;
      pagination: Pagination;
    }>('/permissions/users/all', params);
    return response.data;
  },

  // Grant permission to a user
  grantPermission: async (data: {
    userId: string;
    permissionId: string;
    centerId: string;
  }) => {
    const response = await apiService.post<UserPermission>('/permissions/grant', data);
    return response.data;
  },

  // Revoke permission from a user
  revokePermission: async (data: {
    userId: string;
    permissionId: string;
    centerId: string;
  }) => {
    const response = await apiService.post('/permissions/revoke', data);
    return response.data;
  },

  // Bulk update user permissions
  bulkUpdateUserPermissions: async (data: {
    userId: string;
    centerId: string;
    permissions: string[]; // Array of permission IDs
  }) => {
    const response = await apiService.put('/permissions/user/bulk', data);
    return response.data;
  }
}; 